import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import iconButtonStyle from 'components/CustomButtons/style/iconButtonStyle';

function IconCustomButton({ color, children, customSx, ...rest }) {
  return (
    <IconButton
      {...rest}
      sx={{
        ...iconButtonStyle.button,
        ...(color && iconButtonStyle[color]),
        ...customSx,
      }}
      size='large'>
      {children}
    </IconButton>
  );
}

IconCustomButton.propTypes = {
  color: PropTypes.oneOf([
    'primary',
    'info',
    'success',
    'warning',
    'danger',
    'white',
    'simple',
    'defaultNoBackground',
    'primaryNoBackground',
    'infoNoBackground',
    'successNoBackground',
    'warningNoBackground',
    'dangerNoBackground',
  ]),
  customSx: PropTypes.object,
  disabled: PropTypes.bool,
};

export default IconCustomButton;
